import { useNavigateToPermalink } from "./useNavigateToPermalink"

export function useLink({ path }: { path: string }) {
  const { href } = useNavigateToPermalink(path)

  return {
    href
  }
}
